__turbopack_context__.v({
  "add": "ai-mcp-library-module__txUbBW__add",
  "card": "ai-mcp-library-module__txUbBW__card",
  "cover": "ai-mcp-library-module__txUbBW__cover",
  "description": "ai-mcp-library-module__txUbBW__description",
  "detail": "ai-mcp-library-module__txUbBW__detail",
  "footer": "ai-mcp-library-module__txUbBW__footer",
  "heading": "ai-mcp-library-module__txUbBW__heading",
  "tags": "ai-mcp-library-module__txUbBW__tags",
  "views": "ai-mcp-library-module__txUbBW__views",
});
